import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import {PaginatedRequest} from 'utils/types/store';
import {RecommendationInfo, Recommendation} from './types';

export function fetchRecommendationsRequest(
  params: Record<string, string>,
  page: number,
) {
  const urlParams = new URLSearchParams({...params, limit: `${page * 20}`});

  return useSWR<PaginatedRequest<Recommendation[]>, unknown>(
    [`/api/v1/recommendations/?${urlParams}`, params ?? {}],
    ([url]) => letrusAPI(url).then((res) => res.data),
    {revalidateOnFocus: false},
  );
}

export function updateRecommendationRequest() {
  return useSWRMutation<unknown, unknown, string, RecommendationInfo>(
    '/api/v1/recommendations',
    (_, {arg}) => {
      const {id, ...payload} = arg;
      return letrusAPI(`/api/v1/recommendations/${id}/answer/`, {
        method: 'post',
        data: payload,
      })
        .then((res) => res.data?.results)
        .catch(() => {});
    },
  );
}
